import React from 'react'
import cn from 'classnames'
import validate from 'validate.js'
import { Form, Field } from 'react-final-form'

import { useTranslation } from '@mc/i18n'
import { Button, InputField } from '@mc/design-system'

import { CONSTRAINTS } from 'pages/sessions/classes/[slug]/utils'

export const JoinWaitListForm = ({
  onSubmit,
}: {
  onSubmit: ({ email }: { email: string }) => void
}) => (
  <>
    <div className='d-block d-sm-none'>
      <JoinWaitListFormResponsive ltSM onSubmit={onSubmit} />
    </div>
    <div className='d-none d-sm-block'>
      <JoinWaitListFormResponsive ltSM={false} onSubmit={onSubmit} />
    </div>
  </>
)

const JoinWaitListFormResponsive = ({
  onSubmit,
  ltSM,
}: {
  onSubmit: ({ email }: { email: string }) => void
  ltSM: boolean
}) => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <h3 className='mc-mb-2 mc-text-large'>
        {t('sessions.campHeroCTAs.joinWaitListForm.comingSoon')}
      </h3>
      <div>{t('sessions.campHeroCTAs.joinWaitListForm.joinNow')}</div>

      <Form
        onSubmit={onSubmit}
        validate={(data: { email: string }) =>
          validate(data, CONSTRAINTS, { fullMessages: false })
        }
      >
        {({ handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            className={cn('mc-my-2', {
              'd-flex no-gutters align-items-end': !ltSM,
              'flex-column': ltSM,
            })}
          >
            <Field
              id='emailInput'
              component={InputField}
              name='emailInput'
              autoComplete='email'
              placeholder={t(
                'sessions.campHeroCTAs.joinWaitListForm.emailPlaceHolder',
              )}
              label={t('sessions.campHeroCTAs.joinWaitListForm.email')}
              className='mc-w-100'
            />

            <Button
              type='submit'
              fullWidth={ltSM}
              className={cn({ 'mc-mt-2': ltSM, 'mc-ml-3': !ltSM })}
            >
              {t('sessions.campHeroCTAs.joinWaitListForm.joinCTA')}
            </Button>
          </form>
        )}
      </Form>
      <span className='mc-text-x-small mc-opacity--hinted mc-mt-1'>
        {t('sessions.campHeroCTAs.joinWaitListForm.consent')}
      </span>
    </>
  )
}
